/* import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";
import { Bar } from "react-chartjs-2";

const OnlineVistorsChat = ({ label, visitors }) => {
  ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);
 
  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
        labels: {
          boxWidth: 16,
        },
        display: false,
      },
      title: {
        display: false,
        text: "Amount of Product Sold",
      },
    },
    scales: {
      y: {
        ticks: {
          stepSize: 100,
        },
        title: {
          display: false,
          text: "Sales (in $)",
        },
        grid: {
          display: false,
        },
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
    barThickness: 8,
    borderRadius: 2,
  };

  const labels = label.slice(0,-1);

  const data = {
    labels,
    datasets: [
      {
        data: visitors.slice(0,-1),
        borderColor: "#5887DE",
        backgroundColor: (color) => {
          color = color.index > 10 ? "#E2CCCC" : "#F2F2F2";
          return color;
        },
      },
    ],
  };

  return (
    <>
      <Bar height={200} width={200} data={data} options={options} />
    </>
  );
};

export default OnlineVistorsChat;
 */

import { useEffect, useRef } from "react";
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);

/*
  OnlineVistorsChat
  ─────────────────
  Props:
    label    — string[]  x-axis labels
    visitors — number[]  visitor counts per period
*/
export default function OnlineVistorsChat({ label = [], visitors = [] }) {
  const canvasRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    if (!canvasRef.current) return;
    if (chartRef.current) chartRef.current.destroy();

    chartRef.current = new Chart(canvasRef.current, {
      type: "line",
      data: {
        labels: label,
        datasets: [
          {
            label: "Visitors",
            data: visitors,
            borderColor: "#e2cccc",
            backgroundColor: "rgba(226,204,204,0.2)",
            fill: true,
            tension: 0.4,
            pointRadius: 2,
            pointBackgroundColor: "#e2cccc",
            pointHoverRadius: 4,
            borderWidth: 1.5,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: { mode: "index", intersect: false },
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: (ctx) => ` Visitors: ${ctx.raw}`,
            },
          },
        },
        scales: {
          x: {
            grid: { display: false },
            ticks: {
              color: "rgba(0,0,0,0.35)",
              font: { size: 9 },
              maxRotation: 0,
              maxTicksLimit: 6,
            },
          },
          y: {
            grid: { color: "rgba(0,0,0,0.05)" },
            ticks: { color: "rgba(0,0,0,0.35)", font: { size: 10 } },
            beginAtZero: true,
          },
        },
      },
    });

    return () => {
      if (chartRef.current) chartRef.current.destroy();
    };
  }, [label, visitors]);

  return (
    <div style={{ position: "relative", width: "100%", height: 160 }}>
      <canvas ref={canvasRef} role='img' aria-label='Online visitors area chart' />
    </div>
  );
}
